import * as React from 'react'
import * as DialogPrimitive from '@radix-ui/react-dialog'
import { X } from 'lucide-react'

import { cn } from '@/lib/utils'

const Sheet = DialogPrimitive.Root
const SheetTrigger = DialogPrimitive.Trigger
const SheetClose = DialogPrimitive.Close
const SheetPortal = DialogPrimitive.Portal

function SheetOverlay({ className, ...props }) {
	return (
	<DialogPrimitive.Overlay
		className={cn('fixed inset-0 z-50 bg-black/50 data-[state=open]:animate-in data-[state=closed]:animate-out', className)}
		{...props}
	/>
	)
}

const sideClasses = {
	right: 'right-0 top-0 h-full w-3/4 max-w-sm border-l',
	left: 'left-0 top-0 h-full w-3/4 max-w-sm border-r',
	top: 'left-0 top-0 w-full border-b',
	bottom: 'bottom-0 left-0 w-full border-t',
}

function SheetContent({ side = 'right', className, children, ...props }) {
	return (
	<SheetPortal>
		<SheetOverlay />
		<DialogPrimitive.Content
			className={cn(
				'fixed z-50 bg-background p-6 shadow-lg transition ease-in-out data-[state=open]:animate-in data-[state=closed]:animate-out',
				sideClasses[side],
				className
			)}
			{...props}
		>
			{children}
			<SheetClose className="absolute right-4 top-4 rounded-sm opacity-70 transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
				<X className="h-4 w-4" />
				<span className="sr-only">Close</span>
			</SheetClose>
		</DialogPrimitive.Content>
	</SheetPortal>
	)
}

export { Sheet, SheetTrigger, SheetClose, SheetContent }